import id from './id.js'
import initialState from './initial-state.js'
import selectorDefinitions from './selectors/index.js'

const apyRatesReduxDefinition = {
  id,
  type: 'redux-module',
  initialState,
  eventReducers: {
    apyRates: (state, data) => ({ ...state, loaded: true, data }),
  },
  selectorDefinitions,
}

export default apyRatesReduxDefinition
